




































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import EditFreight from './mainlandfreight-edit.vue'
    import CreateFreight from './mainlandfreight-add.vue'
    import Enums from '@/lib/enums'
    import DateUtils from '@/common/js/DateUtils'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    Vue.use(Preview);

    class PageFreightRequest extends PageRequest {
        beginTime?: Date;
        endTime?: Date;
        site: number;
        cargoCategory: number;
        isEffective?: boolean;
        constructor() {
            super();
            this.isEffective = null;
            this.site = null;
        }
    }

    @Component
        ({
            components: { EditFreight, CreateFreight }
        })
    export default class Freogjt extends AbpBase {
        whetherStatus = Enums.getEnum(Enums.IsEffectiveStatus, true);
        cargoCategoryType = Enums.getEnum(Enums.CargoCategoryType, true);
        siteType = Enums.getEnum(Enums.SiteSType, true);
        pagerequest: PageFreightRequest = new PageFreightRequest();

        creationTime: Date[] = [];
        editModalShow: boolean = false;
        createModalShow: boolean = false;
        get list() {
            return this.$store.state.mainlandfeightinfo.list;
        };
        get loading() {
            return this.$store.state.mainlandfeightinfo.loading;
        }
        async ishandle() {
            this.updateStatus();
        }

        async updateStatus() {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            //  var statuName = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == statu })[0].name;

            this.$Modal.confirm({
                title: "修改本土运费信息", content: "确认批量处理数据？", onOk: async () => {
                    var ids = [];
                    for (var i = 0; i < selection.length; i++) {
                        ids.push(selection[i].id);
                    }
                    await this.$store.dispatch({
                        type: 'mainlandfeightinfo/updateStatus',
                        data: { ids: ids }
                    });
                    this.getpage();

                }
            });
        }
        create() {
            this.createModalShow = true;
        }
        pageChange(page: number) {
            this.$store.commit('mainlandfeightinfo/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('mainlandfeightinfo/setPageSize', pagesize);
            this.getpage();
        }


        async getpage() {

            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            //filters
            if (this.creationTime.length > 0) {
                this.pagerequest.beginTime = this.creationTime[0];
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.endTime = this.creationTime[1];
            }

            await this.$store.dispatch({
                type: 'mainlandfeightinfo/getAll',
                data: this.pagerequest
            })
        }
        ShowModel() {
            this.editModalShow = true;
        }
        get pageSize() {
            return this.$store.state.mainlandfeightinfo.pageSize;
        }
        get totalCount() {
            return this.$store.state.mainlandfeightinfo.totalCount;
        }
        get currentPage() {
            return this.$store.state.mainlandfeightinfo.currentPage;
        }
        columns = [
            {
                type: 'selection',
                width: 50,
                align: 'center',
                fixed: 'left',
            },
            {
                title: '仓库名称',
                key: 'warehouseName',
                align: "center",
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.warehouseName ? params.row.warehouseName : params.row.storeName);
                }
            },
            {
                title: '订单站点',
                width: 140,
                key: 'site',
                render: (h: any, params: any) => {
                    return h('span', Enums.SiteSType.filter(function (item) { return item.value == params.row.site })[0].name);
                }
            }, {
                title: '货物类别',
                width: 140,
                key: 'cargoCategory',
                render: (h: any, params: any) => {
                    return h('span', Enums.CargoCategoryType.filter(function (item) { return item.value == params.row.cargoCategory })[0].name);
                }
            }, {
                title: '首重【g】',
                key: 'firstWeight',
                width: 150,
            }, {
                title: '首重价格',
                key: 'firstWeightPrice',
                width: 150,
            }, {
                title: '续重【g】',
                key: 'continueWeight',
                width: 150,
            },
            {
                title: '续重费用',
                key: 'continueWeightCost',
                width: 150,
            },

            {
                title: '体积重参数',
                key: 'bulkyParameter',
                width: 150,
            }, {
                title: '是否有效',
                width: 150,
                key: 'isEffective',
                render: (h: any, params: any) => {
                    return h('span', params.row.isEffective ? this.L('是') : this.L('否'))
                }
            }, {
                title: '开始时间',
                key: 'beginTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.beginTime ? DateUtils.formatLongDate(new Date(params.row.beginTime)) : '');
                }
            }, {
                title: '结束时间',
                key: 'endTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.endTime ? DateUtils.formatLongDate(new Date(params.row.endTime)) : '');
                }
            }, {
                title: '操作',
                width: 130,
                fixed: 'right',
                key: 'id',
                render: (h: any, params: any) => {
                    var data = params.row;
                    var _this = this;
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '90px',
                                height: '30px',
                                display: data.isEffective == true ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {

                                    _this.$store.state.mainlandfeightinfo.id = data.id;
                                    _this.ShowModel();
                                }
                            }

                        }, "修改结束时间")
                    ]);
                }
            }]
        async created() {
            this.getpage();
        }
    }
